var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"image_box"},[_c('img',{attrs:{"src":_vm.copyRight.business_license,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }